import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const steps = [
  { t: "Factory Visibility Assessment", d: "Review factory goals, critical machines, current reporting, ERP/APS landscape and improvement priorities." },
  { t: "Preconfigured Instance", d: "Prepare BEEDIGIT industry template, users, work centers, loss reasons, quality checks, QR labels and dashboards." },
  { t: "Hardware Installation", d: "Connect machines, tablets, printers, energy trackers and edge devices according to the selected scope." },
  { t: "Calibration & Data Collection", d: "Validate machine signals, output, speed, downtime and energy data." },
  { t: "Operator Training", d: "Train operators, supervisors, maintenance and quality users on real shop-floor workflows." },
  { t: "Go-Live", d: "Start operational use with monitoring, job orders, QR scanning, quality checks and reporting." },
  { t: "First Results Review", d: "Analyze OEE, downtime, output, energy and material flow. Identify improvement actions." },
  { t: "Scale", d: "Expand to additional lines, modules, factories or ERP/APS integrations." },
];

export default function OnboardingTimeline() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border bg-[hsl(var(--section-alt))]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Onboarding")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Fast onboarding. Real factory results step by step.")}</h2>
          <p className="text-muted-foreground">
            {t("BEEDIGIT is designed for fast implementation with preconfigured modules, industrial hardware and industry templates.")}
          </p>
        </div>
        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {steps.map((s, i) => (
            <li key={s.t} className="rounded-lg border border-border bg-card p-4 relative">
              <div className="text-xs font-mono text-primary mb-2">{t("STEP")} {String(i + 1).padStart(2, "0")}</div>
              <h3 className="font-semibold mb-1 text-sm">{t(s.t)}</h3>
              <p className="text-xs text-muted-foreground">{t(s.d)}</p>
            </li>
          ))}
        </ol>
        <div className="mt-8">
          <Button asChild>
            <Link to="/get-started">{t("Plan My BEEDIGIT Start")} <ArrowRight className="ms-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </section>
  );
}